import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomPaginator extends MatPaginatorIntl implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(private translate: TranslateService) {
    super();

    // Init translations
    this.translateLabels();

    // Update on language change
    this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.translateLabels();
    });
  }

  private translateLabels() {
    this.itemsPerPageLabel = this.translate.instant('PAGINATOR.ITEMS_PER_PAGE');
    this.nextPageLabel = this.translate.instant('PAGINATOR.NEXT');
    this.previousPageLabel = this.translate.instant('PAGINATOR.PREV');
    this.firstPageLabel = this.translate.instant('PAGINATOR.FIRST');
    this.lastPageLabel = this.translate.instant('PAGINATOR.LAST');
    this.changes.next();
  }

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }
    length = Math.max(length, 0);
    const totalPages = Math.ceil(length / pageSize);
    return `${page + 1} - ${totalPages}`;
  };

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
